import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  headingTitle: {
    id: 'course-authoring.student-overview.headingTitle',
    defaultMessage: 'Student overview',
  },
  inviteButtonText: {
    id: 'course-authoring.student-overview.inviteButtonText',
    defaultMessage: 'Invite',
  },
  name: {
    id: 'course-authoring.student-overview.name.label',
    defaultMessage: 'Name',
  },
  email: {
    id: 'course-authoring.student-overview.email.label',
    defaultMessage: 'Email',
  },
  startDate: {
    id: 'course-authoring.student-overview.startDate.label',
    defaultMessage: 'Start Date',
  },
  lastActive: {
    id: 'course-authoring.student-overview.lastActive.label',
    defaultMessage: 'Last Active',
  },
  progress: {
    id: 'course-authoring.student-overview.progress.label',
    defaultMessage: 'Progress',
  },
  emptyPlaceHolderTitle: {
    id: 'course-authoring.student-overview.empty-placeholder.title',
    defaultMessage: 'No student activity yet.',
  },
  emptyPlaceHolderDesc: {
    id: 'course-authoring.student-overview.empty-placeholder.desc',
    defaultMessage: 'Once the course is published and learners start enrolling, their progress and scores will be visible here.',
  },
});

export default messages;
